import React from "react";
import "./MemberProfile.css";
import EmailIcon from "./email.svg";
import PhoneIcon from "./phone.svg";

const placeholderText =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

const MemberProfile = ({ member }) => {
  if (!member) {
    return (
      <div className="MemberProfile">
        <div className="member-profile-content">
          <p className="member-profile-missing">Team member not found.</p>
          <a className="back-link" href="/">
            ← Back to our team
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="MemberProfile">
      <div className="member-profile-content">
        <img
          className="member-profile-photo"
          src={member.img}
          alt={member.name}
        />
        <div className="member-profile-text">
          <h1>{member.name}</h1>
          <h2>{member.title}</h2>
          <p>{placeholderText}</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <div className="member-profile-contact">
            <a
              className="contact-pill"
              href={`mailto:${member.email}`}
              aria-label={`Email ${member.name}`}
            >
              <img src={EmailIcon} alt="" className="contact-icon" />
              <span className="sr-only">Email {member.name}</span>
            </a>
            <a
              className="contact-pill"
              href={`tel:${member.phone}`}
              aria-label={`Call ${member.name}`}
            >
              <img src={PhoneIcon} alt="" className="contact-icon" />
              <span className="sr-only">Call {member.name}</span>
            </a>
          </div>
          <a className="back-link" href="/">
            ← Back to our team
          </a>
        </div>
      </div>
    </div>
  );
};

export default MemberProfile;
